<template>
  <div class="pt-5">
    <formAdminAttestationReport />
    <formAdminAttestationReportCharts />
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    emailsSubscriptionChart: {
      data: {
        labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
        series: [
          [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],

        ],
      },
      options: {
        axisX: {
          showGrid: false,
        },
        low: 0,
        high: 1000,
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0,
        },
        height: '200px'
      },
      responsiveOptions: [
        ['screen and (max-width: 640px)', {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0]
            },
          },
        }],
      ],
    },
  }),
  computed: {
    ...mapState('admin/accountInventory', ['attestationReportHeaders'])
  },
  methods: {

  }
}
</script>
<style lang="scss">
.v-card--material-chart.v-card .v-card--material__header {
  max-height: 200px
}
</style>